import React, { Component } from 'react';
import { connect } from 'react-redux';
import { submit, isSubmitting, reduxForm, Field } from 'redux-form';

import { TextField } from 'redux-form-material-ui';

import * as format from 'helpers/Formatter';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';

import * as validator from 'helpers/Validator';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import renderDatePicker from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';

import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';
import { getTranslatedString } from 'helpers/i18n';

let RentersInsuranceUploaderForm = class extends Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <div aria-label={getTranslatedString('clickToAdd.document')} tabIndex="1">
          <Field
            name="new_document.file"
            validate={[validator.required]}
            style={{
              border: `1px dashed ${colors.LIGHT_GRAY}`,
              width: '60%',
              margin: 'auto',
              textAlign: 'center',
            }}
            labelText={getTranslatedString('clickToAdd.document')}
            component={ReduxDropzone}
            size={120}
            multiple={false}
          />
        </div>

        <div className="row" style={{ margin: '30px 50px 0px' }}>
          <div className="col-sm-8 col-sm-offset-2">
            <label
              style={{
                width: '100%',
                textAlign: 'initial',
                fontSize: '11px',
                margin: '11px -10px -10px 15px',
                marginLeft: '15px',
                position: 'absolute',
                top: '-6px',
                left: '15px',
              }}
            >
              {getTranslatedString('dashboard.startDate')}
            </label>
            <Field
              name="renters_insurance_start_date"
              component={renderDatePicker}
              openToYearSelection={true}
              style={{
                marginTop: '-20px',
                marginBottom: 0,
              }}
              textFieldStyle={{
                width: '100%',
                fontSize: '14px',
              }}
              floatingLabelFixed
              type="date"
              formatDate={format.reformatDate}
              autoOk={true}
              fullWidth
              floatingLabelText={getTranslatedString('dashboard.startDate')}
              validate={[validator.required]}
              aria-label={getTranslatedString('dashboard.startDate')}
              tabIndex="1"
            />
          </div>
        </div>

        <div className="row" style={{ margin: '30px 50px 0px' }}>
          <div className="col-sm-8 col-sm-offset-2">
            <label
              style={{
                width: '100%',
                textAlign: 'initial',
                fontSize: '11px',
                margin: '11px -10px -10px 15px',
                marginLeft: '15px',
                position: 'absolute',
                top: '-6px',
                left: '15px',
              }}
            >
              {getTranslatedString('dashboard.expirationDate')}
            </label>
            <Field
              name="renters_insurance_expiry_date"
              component={renderDatePicker}
              openToYearSelection={true}
              style={{
                marginTop: '-20px',
                marginBottom: 0,
              }}
              textFieldStyle={{
                width: '100%',
                fontSize: '14px',
              }}
              floatingLabelFixed
              type="date"
              formatDate={format.reformatDate}
              autoOk={true}
              fullWidth
              minDate={new Date()}
              floatingLabelText={getTranslatedString('dashboard.expirationDate')}
              validate={[validator.required, validator.futureDate]}
              aria-label={getTranslatedString('dashboard.expirationDate')}
              tabIndex="1"
            />
          </div>
        </div>

        <Field
          name="new_document.document_type"
          validate={[validator.required]}
          component={TextField}
          floatingLabelText="Document Type"
          style={{
            visibility: 'hidden',
          }}
        />
      </form>
    );
  }
};

RentersInsuranceUploaderForm = reduxForm({
  form: 'insurance_document_uploader_form',
  enableReinitialize: true,
  initialValues: { new_document: { document_type: 'Insurance Document' } },
})(RentersInsuranceUploaderForm);

class RentersInsuranceUploader extends Component {
  toggleDialog = () => {
    // this.props.change('new_document', null);
    this.props.toggleDialog();
  };

  handleSubmit = data => {
    // handleSubmit is a promise only if the handleSubmit call is successful
    // other handleSubmit will return an error object.
    const submitResponse = this.props.onSubmit(data);
    if (submitResponse.then) {
      submitResponse.then(() => {
        this.toggleDialog();
      });
    }
  };

  render() {
    return (
      <Dialog
        disableBackdropClick
        fullScreen={this.props.fullScreen}
        open={this.props.dialogOpen}
        onClose={this.toggleDialog}
        aria-labelledby="add-new-document"
        classes={{
          paper: 'form-dialog',
        }}
      >
        <DialogTitle id="upload-document">
          <h3 style={{ textAlign: 'center', margin: 0 }}>
            {getTranslatedString('uploadInsuranceDocument')}
          </h3>
        </DialogTitle>
        <DialogContent>
          <RentersInsuranceUploaderForm onSubmit={this.handleSubmit} />
        </DialogContent>

        <DialogActions style={{ display: 'block' }}>
          <FlatButton
            onClick={this.toggleDialog}
            id="close-button"
            style={{ color: AccentColor() }}
            aria-label={getTranslatedString('cancel')}
            tabIndex="1"
          >
            {getTranslatedString('cancel')}
          </FlatButton>
          <FlatButton
            variant="raised"
            onClick={() => this.props.submit('insurance_document_uploader_form')}
            disabled={this.props.submitting}
            id="submit-button"
            style={{
              color: 'white',
              backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
            }}
            aria-label={getTranslatedString('add')}
            tabIndex="1"
          >
            {getTranslatedString('add')}
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withMobileDialog()(
  connect(
    state => ({
      submitting: isSubmitting('insurance_document_uploader_form')(state),
    }),
    { submit }
  )(RentersInsuranceUploader)
);
